import * as duration from "duration-fns";
import { isValid, parseISO } from "date-fns";
import type { Duration } from "duration-fns";

export function parseTimestamp(
  value: duration.DateInput | null | undefined,
): Date | null {
  if (value == null) return null;
  const date = typeof value === "string" ? parseISO(value) : new Date(value);
  return isValid(date) ? date : null;
}

export function safeToSeconds(d: Duration): number {
  const p = d as Partial<Duration>;
  const ms =
    (p.years ?? 0) * 31536000000 +
    (p.months ?? 0) * 2628000000 +
    (p.weeks ?? 0) * 604800000 +
    (p.days ?? 0) * 86400000 +
    (p.hours ?? 0) * 3600000 +
    (p.minutes ?? 0) * 60000 +
    (p.seconds ?? 0) * 1000 +
    (p.milliseconds ?? 0);
  return ms / 1000;
}

export function formatMeetingTimestamp(d: Duration) {
  let s = `${String(d.minutes).padStart(2, "0")}:${String(d.seconds).padStart(2, "0")}`;

  if (d.hours) s = String(d.hours).padStart(2, "0") + ":" + s;
  if (d.days) s = String(d.days).padStart(2, "0") + "d:" + s;
  if (d.weeks) s = String(d.weeks).padStart(2, "0") + "w:" + s;
  if (d.months) s = String(d.months).padStart(2, "0") + "m:" + s;
  if (d.years) s = String(d.years).padStart(2, "0") + "y:" + s;

  return s;
}

export function formatDuration(d: Duration) {
  let s = `${d.minutes} minutes ${d.seconds} seconds`;

  if (d.days) s = String(d.days) + "days " + s;
  if (d.weeks) s = String(d.weeks) + "weeks " + s;
  if (d.months) s = String(d.months) + "months " + s;
  if (d.years) s = String(d.years) + "years " + s;

  return s;
}

export function formatUtteranceDurationShort(d: Duration): string {
  const totalSecs = Math.round(safeToSeconds(d));
  if (totalSecs < 60) return `${totalSecs} secs`;
  const mins = Math.floor(totalSecs / 60);
  const secs = totalSecs % 60;
  if (secs === 0) return `${mins} mins`;
  return `${mins} mins ${secs} secs`;
}

export function normalizedDifferenceDuration(
  a: duration.DateInput,
  b: duration.DateInput,
) {
  return duration.normalize(
    {
      milliseconds: duration.toMilliseconds(duration.between(a, b)),
    },
    b,
  );
}
